import * as go from 'gojs';

export const shakeObject = (obj: go.Part) => {
  const { x, y } = obj.location;
  obj.moveTo(x + 1, y, true);
  obj.moveTo(x, y, true);
};
